import { type WrappedInsightDistanceAndCommuteAttributes } from "@clipboard-health/contract-backend-main";
import { Image, Span, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import carRoadIcon from "../../assets/car-road-wrapped.png";

const TWO_HOURS_IN_MINUTES = 120;

function formatDrivingTime(minutes: number): { value: string; suffix: string } {
  if (minutes >= TWO_HOURS_IN_MINUTES) {
    const hours = minutes / 60;
    return { value: hours.toFixed(1), suffix: "hours" };
  }

  return { value: Math.round(minutes).toString(), suffix: "mins" };
}

interface DistanceAndCommuteContentProps {
  attributes: WrappedInsightDistanceAndCommuteAttributes;
}

export function DistanceAndCommuteContent(props: DistanceAndCommuteContentProps) {
  const { attributes } = props;
  const { value: drivingTimeValue, suffix: drivingTimeSuffix } = formatDrivingTime(
    attributes.averageDrivingTimePerShift
  );

  return (
    <Stack flex={1} position="relative" overflow="hidden">
      {/* Text section - top left */}
      <Stack
        position="absolute"
        sx={{
          top: "15%",
          left: "7.7%",
          right: "7.7%",
          zIndex: 1,
        }}
        spacing={2}
      >
        <Text variant="body1" color="white">
          On average, you spent about
        </Text>

        <Box>
          <Text
            variant="h1"
            color="white"
            sx={{ fontSize: "5rem", lineHeight: 1, display: "inline" }}
          >
            {drivingTimeValue}
          </Text>
          <Span sx={{ fontSize: "1.5rem", color: "white", marginLeft: 1 }}>
            {drivingTimeSuffix}
          </Span>
        </Box>

        <Text variant="body1" color="white">
          driving per shift this year.
        </Text>
      </Stack>

      {/* Car and road image - full width at bottom */}
      <Box
        position="absolute"
        sx={{
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 0,
        }}
      >
        <Image src={carRoadIcon} alt="Car on road" width="100%" height="auto" />
      </Box>
    </Stack>
  );
}
